// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"6950e867","23":"6ea311cd","135":"922d2e1d","288":"270339a2","351":"7b3b6baf","374":"afb7bdf9","436":"60b81267","569":"58500a45","675":"bd2b3e8d","836":"a9a4bfd7"}[chunkId] + ".chunk.js";
};